<template>
  <div class="router-transitions container-fluid flex-grow-1 container-p-y">
    <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      Settings
    </h4>
    <b-card no-body>
      <b-tabs card v-model="tabIndex">
        <b-tab title="General">
          <General />
        </b-tab>
        <b-tab title="Permissions" v-if="can(PN.PERMISSION_CRUD)">
          <Permissions />
        </b-tab>
        <b-tab title="SCIM" v-if="hasScim">
          <Scim />
        </b-tab>
        <b-tab title="SAML" v-if="hasSaml">
          <Saml />
        </b-tab>
        <b-tab title="Audit">
          <Audit />
        </b-tab>
        <b-tab title="Booking">
          <Booking />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import Permissions from '@/components/settings/Permissions.vue'
import Scim from '@/components/settings/Scim.vue'
import { mapState, mapGetters } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import Saml from '@/components/settings/Saml.vue'
import General from '@/components/settings/General.vue'
import Audit from '@/components/settings/Audit.vue'
import Booking from '@/components/settings/Booking.vue'

export default {
  name: 'Settings',
  data() {
    return { PN, tabIndex: 0 }
  },
  components: {
    Permissions,
    Scim,
    Saml,
    General,
    Audit,
    Booking,
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('rbac', ['can']),
    hasScim() {
      return this.user.scim_sync_enabled
    },
    hasSaml() {
      return this.user.saml_auth_enabled
    },
    // the tabs on screen, in order, by the names ?tab= uses - SCIM and SAML are not there
    // for every workspace, so a position would name a different tab from one to the next
    tabs() {
      return [
        'general',
        this.can(PN.PERMISSION_CRUD) && 'permissions',
        this.hasScim && 'scim',
        this.hasSaml && 'saml',
        'audit',
        'booking'
      ].filter(Boolean)
    }
  },
  watch: {
    // the address keeps up with the tab, so a link can open on it and a reload stays there
    tabIndex(index) {
      const tab = this.tabs[index]
      if (!tab || (this.$route.query.tab || this.tabs[0]) === tab) return

      const query = tab === this.tabs[0] ? {} : { tab }
      this.$router.replace({ query }).catch(() => {})
    },
    // a link to another tab while this screen is open reuses the screen rather than building it again
    '$route.query.tab'(tab) {
      this.tabIndex = Math.max(this.tabs.indexOf(tab), 0)
    }
  },
  created() {
    // a tab the workspace does not have opens on General, as a bare link does
    this.tabIndex = Math.max(this.tabs.indexOf(this.$route.query.tab), 0)
  }
}
</script>
